import React from 'react'
import Radium from 'radium'
const ButtonWithIcon = (props) => {
    let iconScale = 0.6;
    const bgStyle = {
        display: 'block',
        width: props.size,
        height: props.size,
        backgroundColor: props.bgColor,
        WebkitMask: `url(${props.background}) no-repeat center`,
        mask: `url(${props.background}) no-repeat center`,
        maskSize: props.size,
        WebkitMaskSize: props.size,
        ':hover': {
            backgroundColor: props.bgColorHover
        },
        ':active': {
            backgroundColor: props.bgColorActive
        }
    }
    let iconStyle = {
        position: 'relative',
        top: props.size * (1 - iconScale) / 2,
        width: props.size * iconScale,
        height: props.size * iconScale
    }
    let disableStyle = {
        pointerEvents: 'none',
        backgroundColor: '#E7E7E7'
    }
    let bgStyles = [];
    bgStyles.push(bgStyle);
    if(props.isDisabled){
        bgStyles.push(disableStyle);
    }
    return  (<div className={props.containerStyle} >
        <div style={bgStyles} onClick={props.onClick}>
                    <img src={props.icon} style={iconStyle} alt=""/>
                </div>
        </div>
    )
}

export default Radium(ButtonWithIcon);